// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__Zuzrp","header":"PatientBlock_header__kyymC","label":"PatientBlock_label__3WEgy","option":"PatientBlock_option__17zAj"};